<div class="column">
  <div class="task--search-bar">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search--input">
      <mat-label>Custom Search</mat-label>
      <input matInput type="text" placeholder="Custom Search" [(ngModel)]="query" (ngModelChange)="onSearch()">
      @if (query) {
      <button matSuffix mat-icon-button aria-label="close" (click)="clearSerch()">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="status">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryStatus && queryStatus !=='all'">
          <app-status-indicator [statusText]="queryStatus" [isDropdownOption]="true"></app-status-indicator>
        </mat-select-trigger>
        <mat-option value="all" class="all"><mat-icon [svgIcon]="icons.FilterOffIcon" />All</mat-option>
        <mat-option [value]="TaskStatusEnum.OPEN"><app-status-indicator [statusText]="TaskStatusEnum.OPEN"
            [isDropdownOption]="true"></app-status-indicator></mat-option>
        <mat-option [value]="TaskStatusEnum.APPROVED"><app-status-indicator [statusText]="TaskStatusEnum.APPROVED"
            [isDropdownOption]="true"></app-status-indicator></mat-option>
        <mat-option [value]="TaskStatusEnum.DECLINED"><app-status-indicator [statusText]="TaskStatusEnum.DECLINED"
            [isDropdownOption]="true"></app-status-indicator></mat-option>
        <mat-option [value]="TaskStatusEnum.ACKNOWLEDGED"><app-status-indicator [statusText]="TaskStatusEnum.ACKNOWLEDGED"
            [isDropdownOption]="true"></app-status-indicator></mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="user-type">
      <mat-label>User type</mat-label>
      <mat-select [(ngModel)]="queryUserType" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryUserType">
          <app-enrollment-type-indicator
            [enrollmentType]="EnrollmentTypeStrMap.get(queryUserType)"></app-enrollment-type-indicator>
        </mat-select-trigger>
        <mat-option value="" class="all"><mat-icon [svgIcon]="icons.FilterOffIcon" /> All</mat-option>
        <mat-option *ngFor="let userType of userTypes" [value]="userType">
          <app-enrollment-type-indicator
            [enrollmentType]="EnrollmentTypeStrMap.get(userType)"></app-enrollment-type-indicator>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="task-type">
      <mat-label>Task type</mat-label>
      <mat-select [(ngModel)]="queryType" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryType">
          <app-request-type-indicator [taskType]="queryType"></app-request-type-indicator>
        </mat-select-trigger>
        <mat-option value="" class="all"><mat-icon [svgIcon]="icons.FilterOffIcon" /> All</mat-option>
        <mat-option *ngFor="let taskType of taskTypes" [value]="taskType">
          <app-request-type-indicator [taskType]="taskType"></app-request-type-indicator>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input [(ngModel)]="queryStart" (ngModelChange)="onFilter()" matStartDate placeholder="Start date">
        <input [(ngModel)]="queryEnd" (ngModelChange)="onFilter()" matEndDate placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

  </div>

  <div class="mat-elevation-z8">
    <table mat-table matSort aria-label="Elements">

      <!-- Id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Task No.</th>
        <td mat-cell *matCellDef="let row">{{row.id}}</td>
      </ng-container>

      <!-- DateReceived Column -->
      <ng-container matColumnDef="dateReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Received</th>
        <td mat-cell *matCellDef="let row">{{row.dateReceived | date:'MM/dd/yyyy HH:mm'}}</td>
      </ng-container>

      <!-- Action Items Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Type</th>
        <td mat-cell *matCellDef="let row">
          <app-request-type-indicator [taskType]="row.type"></app-request-type-indicator>
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">{{row.description}}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <app-status-indicator [statusText]="row.status"></app-status-indicator>
        </td>
      </ng-container>

      <!-- Suspected Rental rows are worked from here (QA 2026-09-23): Create case / Dismiss. -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="row-actions" (click)="$event.stopPropagation()">
          @if (row.type === TaskType.SUSPECTED_RENTAL && row.status === TaskStatus.OPEN) {
            <button mat-flat-button color="primary" (click)="createCase(row)">Create case</button>
            <button mat-stroked-button color="warn" [routerLink]="['/app/discovery', row.relatedEntityId]"
                    [queryParams]="{ dismiss: 1 }">Dismiss</button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="clickable" mat-row *matRowDef="let row; columns: displayedColumns;"
        [class.disabled]="row.status === TaskStatus.LOCKED"
        [routerLink]="row.status === TaskStatus.LOCKED? [] : ['/app/tasks', row.id]"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No data matching the filter.
        </td>
      </tr>
    </table>

    <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
    </mat-paginator>
  </div>
</div>